var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f14",attrs:{"id":"footer"}},[_c('span',[_vm._v("通讯地址："+_vm._s(_vm.address))]),_c('span',[_vm._v("邮编："+_vm._s(_vm.post))]),_c('span',[_vm._v(_vm._s(_vm.signature))]),_c('span',[_vm._v("京ICP备19042963号-1")])])}
var staticRenderFns = []

export { render, staticRenderFns }